import { useEffect } from "react";
import { useSelector } from "react-redux";

export function useError(cb) {
  const errors = useSelector((state) => state.users.errors);
  const status = useSelector((state) => state.users.status);

  useEffect(() => {
    if (status === "success") {
      cb();
    }
  }, [status]);

  return { errors, status };
}
